import { apiInstance } from "@/api/instance";

export default async function (counselId, params) {
  return apiInstance.get(`/counsel/${counselId}`, { params });
}
